import { NAME } from './constants';
import { router } from './router';

export const WmsJobController = {
	name: NAME,
	router,
};
